function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import getDisplayName from '../../getDisplayName';
import { FormUIStateContext } from '../BlueBoxZone/BlueBoxZone';
import set from '../../utils/set';
import BlueBox from '../BlueBox/BlueBox';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import Draggable from '../../DragNDrop/Draggable/Draggable';
import EditForm from '../../SchemaForm/EditForm/EditForm';
import I18n from '../../I18n/I18n/I18n';
import Button from '../../Buttons/Button/Button';
import ButtonGroup from '../../Buttons/ButtonGroup/ButtonGroup';
import Modal from '../../Modal/Modal/Modal';
import ModalBody from '../../Modal/ModalBody/ModalBody';
import ModalFooter from '../../Modal/ModalFooter/ModalFooter';
import ModalWrapper from '../../Modal/ModalWrapper/ModalWrapper';
import ThemeContext from '../../ThemeContext';
import WidgetSizeContext from '../../SchemaForm/WidgetSizeContext/WidgetSizeContext';
function immutableSplice(start, end) {
  for (var _len = arguments.length, items = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    items[_key - 2] = arguments[_key];
  }
  return function (arr) {
    var copy = Array.from(arr);
    copy.splice.apply(copy, [start, end].concat(items));
    return copy;
  };
}
export function Addables(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.addables.map(function (item) {
    return /*#__PURE__*/React.createElement(Button, {
      className: item.className,
      key: item.label,
      onClick: function onClick() {
        return props.onAddItem(item);
      }
    }, /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: item.label
    }));
  }));
}
var FormBuilding = /*#__PURE__*/function (_React$Component) {
  _inherits(FormBuilding, _React$Component);
  function FormBuilding(props) {
    var _this;
    _classCallCheck(this, FormBuilding);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormBuilding).call(this, props));
    _this.setBoxRef = function (ref) {
      _this.boxRef = ref;
    };
    _this.handleApply = function () {
      if (_this.submitRef && _this.submitRef.current) {
        _this.submitRef.current.click();
      }
    };
    _this.onError = function () {
      _this.props.hooks.setError(_this.props.id);
      _this.boxRef && _this.boxRef.focus();
    };
    _this.handleSubmit = function () {
      var _this$props$formConte = _this.props.formContext,
        schema = _this$props$formConte.schema,
        uiSchema = _this$props$formConte.uiSchema,
        onUpdateAllSchema = _this$props$formConte.onUpdateAllSchema;
      var id = _this.props.id.replace(/^_/, '');
      var schemas = _this.props.updater(id, {
        schema: schema,
        uiSchema: uiSchema,
        formData: _this.state
      });
      onUpdateAllSchema(schemas);
      _this.props.hooks.setError('');
      _this.props.hooks.setEditing('');
    };
    _this.handleChange = function (data) {
      if (_this.props.updateSchemas) {
        var schemas = _this.props.updateSchemas(data, _this.state);
        if (schemas) {
          _this.props.onSchemaChange(schemas);
          if (schemas.data) {
            data = schemas.data;
          }
        }
      }
      var filteredState = Object.keys(data).reduce(function (acc, next) {
        acc[next] = data[next] || undefined;
        return acc;
      }, {});
      _this.setState(filteredState);
    };
    _this.handleDelete = function () {
      var _this$props$formConte2 = _this.props.formContext,
        schema = _this$props$formConte2.schema,
        uiSchema = _this$props$formConte2.uiSchema,
        onUpdateAllSchema = _this$props$formConte2.onUpdateAllSchema;
      var id = _this.props.id.replace(/^_/, '');
      var x = uiSchema[id],
        newUISchema = _objectWithoutProperties(uiSchema, [id].map(_toPropertyKey));
      var _schema$properties = schema.properties,
        y = _schema$properties[id],
        properties = _objectWithoutProperties(_schema$properties, [id].map(_toPropertyKey));
      var existingIndex = uiSchema['dm:layout'].findIndex(function (val) {
        return val.id === id;
      });
      var layout = immutableSplice(existingIndex, 1)(uiSchema['dm:layout']);
      _this.props.hooks.setError('');
      onUpdateAllSchema({
        schema: _objectSpread({}, schema, {
          properties: properties
        }),
        uiSchema: set('dm:layout')(layout)(newUISchema)
      });
    };
    _this.onAddItem = function (item) {
      var addSchemas = item.getAddSchemas();
      var _this$props$formConte3 = _this.props.formContext,
        schema = _this$props$formConte3.schema,
        uiSchema = _this$props$formConte3.uiSchema,
        onUpdateAllSchema = _this$props$formConte3.onUpdateAllSchema;
      var newSchema = schema;
      if (addSchemas.schema) {
        var properties = _objectSpread({}, schema.properties, addSchemas.schema.properties);
        newSchema = set("properties")(properties)(schema);
      }
      var newUISchema = uiSchema;
      if (addSchemas.uiSchema) {
        var checkId = _this.props.id.replace(/^_/, '');
        var existingIndex = uiSchema['dm:layout'].findIndex(function (val) {
          return val.id === checkId;
        });
        var layout = uiSchema['dm:layout'],
          rest = _objectWithoutProperties(uiSchema, ["dm:layout"]);
        var _addSchemas$uiSchema = addSchemas.uiSchema,
          addLayout = _addSchemas$uiSchema['dm:layout'],
          addRest = _objectWithoutProperties(_addSchemas$uiSchema, ["dm:layout"]);
        newUISchema = _objectSpread({}, rest, addRest, {
          'dm:layout': immutableSplice.apply(void 0, [existingIndex + 1, 0].concat(_toConsumableArray(addLayout)))(layout)
        });
      }
      onUpdateAllSchema({
        schema: newSchema,
        uiSchema: newUISchema
      });
    };
    _this.renderAddables = function () {
      var formContext = _this.props.formContext;
      if (formContext.isAddable && formContext.addables) {
        return /*#__PURE__*/React.createElement(Addables, {
          addables: formContext.addables,
          onAddItem: _this.onAddItem
        });
      } else {
        return null;
      }
    };
    _this.submitRef = React.createRef();
    if (props.getInitialFormData) {
      _this.state = props.getInitialFormData(props);
    }
    return _this;
  }
  _createClass(FormBuilding, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        Component = _this$props.Component,
        items = _this$props.items,
        state = _this$props.state,
        hooks = _this$props.hooks,
        idAttribute = _this$props.idAttribute,
        editSchema = _this$props.editSchema,
        editUISchema = _this$props.editUISchema,
        editTransformErrors = _this$props.editTransformErrors,
        editArrayFieldTemplate = _this$props.editArrayFieldTemplate,
        editValidate = _this$props.editValidate,
        formContext = _this$props.formContext;
      var theme = this.context;
      var trimmedId = id.replace(/^_/, '');
      var index = idAttribute ? items.findIndex(function (val) {
        return val[idAttribute] === trimmedId;
      }) : items.indexOf(trimmedId);
      var active = state.active === id || state.active === trimmedId;
      var hover = state.hover === id || state.hover === trimmedId;
      var edit = state.edit === id || state.edit === trimmedId;
      var draggable = !edit && (active || hover || state.dragging) && formContext.isRearrangeable;
      return /*#__PURE__*/React.createElement(Draggable, {
        key: id,
        draggableId: id,
        index: index,
        isDragDisabled: !draggable
      }, function (provided, snapshot) {
        return /*#__PURE__*/React.createElement(ModalWrapper, null, function (_ref) {
          var mounted = _ref.mounted,
            triggerClose = _ref.triggerClose,
            triggerOpen = _ref.triggerOpen;
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BlueBox, {
            boxRef: _this2.setBoxRef,
            active: active,
            edit: edit,
            hover: hover && !state.dragging,
            provided: provided,
            snapshot: snapshot,
            onClick: hooks.onClick,
            onDoubleClick: hooks.onDoubleClick,
            onMouseEnter: hooks.onMouseEnter,
            onMouseLeave: hooks.onMouseLeave,
            onFocus: hooks.onFocus,
            onBlur: hooks.onBlur,
            onApply: _this2.handleApply,
            setEditing: hooks.setEditing,
            setActive: hooks.setActive,
            draggable: draggable,
            dragging: state.dragging
            // onDelete={this.handleDelete}
            ,
            onDelete: triggerOpen,
            isDeletable: formContext.isDeletable,
            addables: _this2.renderAddables(),
            id: id,
            theme: theme
          }, edit && editSchema ? /*#__PURE__*/React.createElement(WidgetSizeContext.Consumer, null, function (widgetSize) {
            return /*#__PURE__*/React.createElement(EditForm, {
              editSchema: typeof editSchema === 'function' ? editSchema(_this2.props) : editSchema,
              editUISchema: typeof editUISchema === 'function' ? editUISchema(_this2.props) : editUISchema,
              editTransformErrors: editTransformErrors,
              editArrayFieldTemplate: editArrayFieldTemplate,
              editValidate: editValidate,
              formData: _this2.state,
              onError: _this2.onError,
              onChange: _this2.handleChange,
              onSubmit: _this2.handleSubmit,
              size: widgetSize
            }, /*#__PURE__*/React.createElement("button", {
              ref: _this2.submitRef,
              type: "submit",
              hidden: true,
              className: "hidden"
            }, "Submit"));
          }) : /*#__PURE__*/React.createElement(Component, Object.assign({
            uiState: state,
            active: active,
            edit: edit
          }, _this2.props, {
            readonly: true
          }))), /*#__PURE__*/React.createElement(Modal, {
            titleText: "Confirm Delete",
            mounted: mounted,
            maxWidth: 480,
            includeCloseX: false,
            onExit: triggerClose
          }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(I18n, {
            i18n: "@dm/components.form-builder.messages.confirm-delete"
          }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(I18n, {
            i18n: "@dm/components.form-builder.messages.cannot-undo"
          })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(ButtonGroup, {
            position: theme === 'ripple' ? 'right' : 'center'
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: triggerClose,
            className: "_dm-button auto-modal-footer-button-cancel"
          }, /*#__PURE__*/React.createElement(I18n, {
            i18n: "@dm/components.form-builder.labels.cancel"
          })), /*#__PURE__*/React.createElement(Button, {
            className: "_dm-button auto-modal-footer-button-confirm",
            modifier: theme === 'ripple' ? 'delete' : 'basic',
            onClick: function onClick() {
              triggerClose();
              _this2.handleDelete();
            }
          }, /*#__PURE__*/React.createElement(I18n, {
            i18n: "@dm/components.form-builder.labels.delete"
          }))))));
        });
      });
    }
  }]);
  return FormBuilding;
}(React.Component);
FormBuilding.contextType = ThemeContext;
export default function withFormBuilding(editSchemas) {
  return function (WrappedComponent) {
    var _Class;
    return _Class = /*#__PURE__*/function (_React$Component2) {
      _inherits(_Class, _React$Component2);
      function _Class(props) {
        var _this3;
        _classCallCheck(this, _Class);
        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(_Class).call(this, props));
        _this3.handleSchemaChange = function (_ref2) {
          var schema = _ref2.schema,
            uiSchema = _ref2.uiSchema,
            ArrayFieldTemplate = _ref2.ArrayFieldTemplate;
          _this3.setState(function () {
            return {
              ArrayFieldTemplate: ArrayFieldTemplate,
              schema: schema,
              uiSchema: uiSchema
            };
          });
        };
        _this3.state = {
          ArrayFieldTemplate: editSchemas.ArrayFieldTemplate,
          uiSchema: editSchemas.uiSchema,
          schema: editSchemas.schema
        };
        return _this3;
      }
      _createClass(_Class, [{
        key: "updateSchemas",
        value: function updateSchemas(newData, prevData) {
          return editSchemas.updateSchemas(newData, prevData);
        }
      }, {
        key: "render",
        value: function render() {
          var _this4 = this;
          return /*#__PURE__*/React.createElement(FormUIStateContext.Consumer, null, function (_ref3) {
            var state = _ref3.state,
              hooks = _ref3.hooks,
              items = _ref3.items,
              idAttribute = _ref3.idAttribute;
            return /*#__PURE__*/React.createElement(FormBuilding, Object.assign({
              state: state,
              hooks: hooks,
              items: items,
              idAttribute: idAttribute,
              Component: WrappedComponent,
              getInitialFormData: editSchemas.getInitialFormData,
              editSchema: _this4.state.schema,
              editUISchema: _this4.state.uiSchema,
              editTransformErrors: editSchemas.transformErrors,
              editArrayFieldTemplate: _this4.state.ArrayFieldTemplate,
              editValidate: editSchemas.validate,
              onSchemaChange: _this4.handleSchemaChange,
              updateSchemas: editSchemas.updateSchemas ? _this4.updateSchemas : null,
              updater: editSchemas.updater
            }, _this4.props));
          });
        }
      }]);
      return _Class;
    }(React.Component), _Class.displayName = "WithFormBuilding(".concat(getDisplayName(WrappedComponent), ")"), _Class;
  };
}